class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.headerContainer = document.querySelector(".atd-header-wrapper");
    this.header = document.querySelector("sticky-header");
    this.setHeaderCartIconAccessibility();
    this.onBodyClick = this.handleBodyClick.bind(this);
    this.drawer = document.querySelector(".atd-header drawer-menu");
    this.drawer_menu = this.drawer.querySelector(".drawer");
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector("#cart-icon-bubble");
    if (!cartLink) return;

    cartLink.setAttribute("role", "button");
    cartLink.setAttribute("aria-haspopup", "dialog");

    cartLink.addEventListener("click", (event) => {
      event.preventDefault();
      if (this.classList.contains("active")) {
        this.close();
      } else {
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);

    setTimeout(() => {
      this.drawer_menu.removeAttribute("open");
      this.drawer.closeMenuDrawer();
      this.classList.add("active");
      document.body.addEventListener("click", this.onBodyClick);
      document.body.style.overflow = "hidden";
      this.headerContainer.classList.add("menu-always");
    });
  }

  close() {
    this.classList.remove("active");
    document.body.addEventListener("click", this.onBodyClick);
    document.body.removeAttribute("style");
    this.headerContainer.classList.remove("menu-always");
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      if (this.header) this.header.reveal();
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser().parseFromString(html, "text/html").querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-drawer",
        selector: "#CartDrawer",
      },
      {
        id: "cart-icon-bubble",
      },
    ];
  }

  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser().parseFromString(html, "text/html").querySelector(selector);
  }

  handleBodyClick(evt) {
    if (!evt.target.closest("#CartDrawer")) {
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: "CartDrawer",
        section: "cart-drawer",
        selector: ".drawer__inner",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
    ];
  }
}

customElements.define("cart-drawer-items", CartDrawerItems);
